import { forwardRef, type ComponentPropsWithRef } from "react";

import { Direction } from "../types";

interface AirFlowProps extends ComponentPropsWithRef<"svg"> {
  direction?: Direction;
}

const AirFlow: React.FC<AirFlowProps> = forwardRef<SVGSVGElement, AirFlowProps>(
  ({ direction = Direction.RIGHT, ...props }, forwardedRef) => (
    <svg
      ref={forwardedRef}
      width="45"
      height="24"
      viewBox="0 0 45 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${direction === Direction.RIGHT ? 0 : 180}deg)` }}
      {...props}
    >
      <path
        d="M27.6842 18.2727H1C0.447715 18.2727 0 17.825 0 17.2727V11.4773V6.72727C0 6.17499 0.447716 5.72727 1 5.72727H27.6842C28.2365 5.72727 28.6842 5.27956 28.6842 4.72727V2.47905C28.6842 1.65889 29.6172 1.18748 30.2774 1.67401L43.8571 11.6805C44.4139 12.0909 44.396 12.9291 43.8221 13.3153L30.2424 22.4516C29.5782 22.8985 28.6842 22.4225 28.6842 21.6219V19.2727C28.6842 18.7204 28.2365 18.2727 27.6842 18.2727Z"
        fill="url(#paint0_linear_25482_68346)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_25482_68346"
          x1="-10"
          y1="12"
          x2="48.3627"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.403846" stopColor="#D0D0D0" />
        </linearGradient>
      </defs>
    </svg>
  ),
);

AirFlow.displayName = "AirFlow";

export { AirFlow };
export type { AirFlowProps };
